module.exports = __webpack_public_path__ + "static/img/rancher_logo.1f443b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/rancher_logo.jpg
// module id = UjPg
// module chunks = 2